import * as yup from 'yup';
import { validateDocument } from '../../../pages/Clientes/documentUtils';
import { PAYMENT_METHODS, PaymentMethod } from './helpers/paymentMethods';

export interface IPaymentLinkFormValues {
  // Link sem cliente: os dados de quem paga vão no submit, então o form passa a exigir mais campos.
  requiresCustomerData: boolean;

  name: string;
  email: string;
  document: string;
  phone: string;

  paymentMethodSelected: PaymentMethod;

  cardHolderName: string;
  cardNumber: string;
  cardExpiration: string;
  cardCvv: string;

  zipCode: string;
  state: string;
  city: string;
  address: string;
  addressNumber: string;
  neighborhood: string;
  addressComplement: string;
}

export const INITIAL_PAYMENT_LINK_VALUES: IPaymentLinkFormValues = {
  requiresCustomerData: false,
  name: '',
  email: '',
  document: '',
  phone: '',
  paymentMethodSelected: 'credit_card',
  cardHolderName: '',
  cardNumber: '',
  cardExpiration: '',
  cardCvv: '',
  zipCode: '',
  state: '',
  city: '',
  address: '',
  addressNumber: '',
  neighborhood: '',
  addressComplement: '',
};

const requiredForCreditCard = (message: string) =>
  yup.string().when('paymentMethodSelected', {
    is: 'credit_card',
    then: schema => schema.required(message),
    otherwise: schema => schema.notRequired(),
  });

const requiredForNewCustomer = (message: string) =>
  yup.string().when('requiresCustomerData', {
    is: true,
    then: schema => schema.trim().required(message),
    otherwise: schema => schema.notRequired(),
  });

const PHONE_DIGITS = [10, 11];

export const paymentLinkSchema = yup.object({
  requiresCustomerData: yup.boolean(),
  paymentMethodSelected: yup
    .string()
    .oneOf(Object.keys(PAYMENT_METHODS))
    .required('Selecione um método de pagamento.'),
  name: requiredForNewCustomer('O nome é obrigatório.'),
  email: requiredForNewCustomer('O e-mail é obrigatório.')
    .email('Informe um e-mail válido.'),
  document: requiredForNewCustomer('O CPF/CNPJ é obrigatório.').test(
    'valid-document',
    'Informe um CPF ou CNPJ válido.',
    (value, { parent }) =>
      !parent.requiresCustomerData || !value || validateDocument(value) === null,
  ),
  phone: yup
    .string()
    .test(
      'valid-phone',
      'Informe um telefone válido.',
      value => !value || PHONE_DIGITS.includes(value.replace(/\D/g, '').length),
    ),

  cardHolderName: requiredForCreditCard('O nome do titular do cartão é obrigatório.',),
  cardNumber: requiredForCreditCard('O número do cartão é obrigatório.',),
  cardExpiration: requiredForCreditCard('A validade do cartão é obrigatória.',),
  cardCvv: requiredForCreditCard('O CVV é obrigatório.',),

  zipCode: yup.string().trim().required('O CEP é obrigatório.'),
  state: yup.string().trim().required('O estado é obrigatório.'),
  city: yup.string().trim().required('A cidade é obrigatória.'),
  address: yup.string().trim().required('O endereço é obrigatório.'),
  addressNumber: yup.string().trim().required('O número é obrigatório.'),
  neighborhood: requiredForNewCustomer('O bairro é obrigatório.'),
  addressComplement: yup.string(),
});

export type PaymentLinkFormValues =
  yup.InferType<typeof paymentLinkSchema>;
